import { render, staticRenderFns } from "./ReviewRentChanges.vue?vue&type=template&id=b5f69750&scoped=true&"
import script from "./ReviewRentChanges.vue?vue&type=script&lang=js&"
export * from "./ReviewRentChanges.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRentChanges.vue?vue&type=style&index=0&id=b5f69750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f69750",
  null
  
)

export default component.exports